import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import * as serviceWorker from './serviceWorker';
import axios from 'axios';

import reducers from './reducers';
import AllRoutes from './components/routers/AllRoutes'


export const store = createStore(
    (reducers),
    composeWithDevTools(
        applyMiddleware(promise, thunk)
    )
);

// Global Axios response interceptor to capture refreshed JWT tokens
axios.interceptors.response.use(function (response) {
    var newToken = response.headers['x_auth_token'];
    if (newToken) {
        var userData = localStorage.getItem('user');
        if (userData) {
            try {
                var user = JSON.parse(userData);
                if (user && user.token !== newToken) {
                    user.token = newToken;
                    localStorage.setItem('user', JSON.stringify(user));
                }
            } catch (e) {
                // ignore parse errors
            }
        }
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});

ReactDOM.render(
    <Provider store={store}>
        <AllRoutes />
    </Provider>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
